import { __awaiter, __generator } from "tslib";
import { fetchCapabilities } from '@office-start/capabilities-service';
import { fetchIdentity } from '@office-start/identity-service';
import { KnownInstrumentationEvents } from '@office-start/instrumentation-types';
import { getHarmonyAppDefinitions } from '@office-start/mos-app-utilities';
import { format } from '@office-start/string-formatter-utility';
import { logError } from '@office-start/telemetry-service';
import { applyOfficeIdentity, httpGet } from '@office-start/xhr-service';
import { appLookupUrlFormat } from '../constants/api';
/**
 * Download the latest M365 apps definition from MOS3`
 * @param m365AppsDefinitionLookupServiceProps - {@link M365AppDefinitionLookupServiceProps}
 * @returns Promise containing a list of {@link HarmonyAppDefinition}
 */
export var lookupM365AppDefinition = function (_a) {
    var officeComponentContext = _a.officeComponentContext;
    return __awaiter(void 0, void 0, void 0, function () {
        var capabilities, url, requestConfig, identity, response, _b, debugInfo;
        var _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, fetchCapabilities()];
                case 1:
                    capabilities = _d.sent();
                    if (!(capabilities === null || capabilities === void 0 ? void 0 : capabilities.m365AppsEnabled)) {
                        return [2 /*return*/, []];
                    }
                    url = format(appLookupUrlFormat, officeComponentContext.officeHomeApiRoot, '');
                    requestConfig = {
                        method: "GET" /* HttpRequestMethod.Get */,
                        responseType: "json" /* HttpResponseContentType.Json */,
                        url: url,
                    };
                    return [4 /*yield*/, fetchIdentity()];
                case 2:
                    identity = _d.sent();
                    return [4 /*yield*/, applyOfficeIdentity(requestConfig, officeComponentContext.inMockMode, officeComponentContext.workload, function () { return Promise.resolve(identity); })];
                case 3:
                    _d.sent();
                    _d.label = 4;
                case 4:
                    _d.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, httpGet(KnownInstrumentationEvents.M365AppsDefinitionLookupRequest, "M365_Apps_Definition_Not_Found_In_Config_Retrying_Lookup" /* KnownRequestInstrumentationEvents.M365AppsDefinitionLookupRequest */, requestConfig.url, requestConfig, officeComponentContext.jwtAuthEnabled, officeComponentContext.getAccessToken, officeComponentContext.officeHomeApiRoot, officeComponentContext.correlationId, 'OfficeHome', {}, "network-only" /* FetchStrategy.NetworkOnly */)];
                case 5:
                    response = _d.sent();
                    return [3 /*break*/, 7];
                case 6:
                    _b = _d.sent();
                    return [3 /*break*/, 7];
                case 7:
                    if (!response || !response.ok || !response.data) {
                        debugInfo = !!response
                            ? "Response is truthy,\n            is OK?: ".concat(response === null || response === void 0 ? void 0 : response.ok, ",\n            has data?: ").concat(Boolean(response === null || response === void 0 ? void 0 : response.data), ",\n            response code: ").concat(response === null || response === void 0 ? void 0 : response.status)
                            : 'Response is falsy';
                        logError({
                            eventName: KnownInstrumentationEvents.M365AppsDefinitionLookupError,
                            errorType: 'App_Initialization_Error',
                            message: "Failed to retrieve user's apps.",
                            debugInfo: debugInfo,
                        });
                        return [2 /*return*/, []];
                    }
                    return [2 /*return*/, getHarmonyAppDefinitions((_c = response.data.getAcquisitionsResponse) === null || _c === void 0 ? void 0 : _c.acquisitions)];
            }
        });
    });
};
//# sourceMappingURL=lookupM365AppDefinition.js.map